<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')"/>
    <MenuHealthCompact v-else/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a class="cursor-pointer">Operational Clarity</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Tasks</a></li>
        </ul>

        <div v-if="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Tasks</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callNewTask" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>New Task</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callManageSprints" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Manage Sprints</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="col-12 md:col-12">
                        <div class="card p-fluid">
                            <div class="p-grid">

                                <div class="datatable-scroll-container">

                                    <DataTable
                                        v-model:lazyParams="lazyParams"
                                        :value="tasks"
                                        :rowClass="rowClass"
                                        lazy
                                        paginator
                                        scrollable
                                        responsiveLayout="scroll"
                                        :rows="100"
                                        :totalRecords="totalRecords"
                                        :loading="loading"
                                        :rowsPerPageOptions="[10, 20, 50, 100]"
                                        :sortMode="'multiple'"
                                        :rowHover="true"
                                        :striped-rows="true"
                                        :reorderableColumns="true"
                                        filterDisplay="menu"
                                        :globalFilterFields="['id', 'clientName', 'description', 'sprintName', 'processName']"
                                        @page="onPage"
                                        @sort="onSort"
                                        @filter="onFilter">

                                        <template #header>
                                            <div class="p-grid">
                                                <div class="grid">
                                                    <div class="col-12 lg:col-3 p-2">
                                                        <Dropdown v-model="selectedStatus"
                                                                  :options="standardStatus"
                                                                  optionLabel="name" optionValue="code"
                                                                  placeholder="Select a Status"
                                                                  @update:modelValue="onToggleStatus"/>
                                                    </div>
                                                    <div class="col-12 lg:col-3 p-2">
                                                        <Dropdown v-model="selectedType"
                                                                  :options="standardTypes"
                                                                  optionLabel="name" optionValue="code"
                                                                  placeholder="Select a Type"
                                                                  @update:modelValue="onToggleTypes"/>
                                                    </div>
                                                    <div class="col-12 lg:col-2 p-2">
                                                        <Dropdown v-model="selectedCategory"
                                                                  :options="standardCategories"
                                                                  optionLabel="name" optionValue="code"
                                                                  placeholder="Select a Category"
                                                                  @update:modelValue="onToggleCategories"/>
                                                    </div>
                                                    <div class="col-12 lg:col-2 p-2">
                                                        <Dropdown v-model="selectedFilter"
                                                                  :options="standardFilters"
                                                                  optionLabel="name" optionValue="code"
                                                                  placeholder="Select a Filter"
                                                                  @update:modelValue="onToggleFilters"/>
                                                    </div>

                                                    <div class="col-12 lg:col-2 p-2">
                                                        <Dropdown v-model="selectedFormat"
                                                                  :options="formats"
                                                                  optionLabel="name" optionValue="code"
                                                                  placeholder="Select a Format"
                                                                  @update:modelValue="onFormatChange"/>
                                                    </div>

                                                </div>

                                                <div class="grid">
                                                    <div class="col-12 lg:col-6 p-2">
                                                        <MultiSelect v-model="selectedColumns"
                                                                     :options="columnsFullList"
                                                                     optionLabel="header"
                                                                     optionValue="field"
                                                                     @change="onToggleColumns"
                                                                     display="chip"
                                                                     placeholder="Select Columns"
                                                                     :filter="true"
                                                                     filterPlaceholder="Search columns..."
                                                                     :virtualScrollerOptions="{ itemSize: 40 }"/>
                                                    </div>

                                                    <div class="col-12 lg:col-3 p-2">
                                                        <Button type="button" icon="pi pi-filter-slash"
                                                                label="Clear Search"
                                                                class="p-button-outlined p-ml-2"
                                                                @click="clearFilter()"/>
                                                    </div>
                                                    <div class="col-12 lg:col-3 p-2">
                                                        <Button type="button" icon="pi pi-replay"
                                                                label="Restore to Original View"
                                                                class="p-button-outlined" @click="restoreToOriginal()"/>
                                                    </div>
                                                </div>

                                                <div class="p-col-12 p-md-2">
                                                <span class="p-input-icon-left">
                                                    <i class="pi pi-search"/>
                                                    <InputText v-model="filters['global'].value"
                                                               placeholder="Keyword Search on Keyword Search on ID, Process Name, Client Name, Sprint Name or Description (Please press enter to search)"
                                                               style="width: 100%"
                                                               @keyup.enter="onSearch"/>

                                                </span>
                                                </div>
                                            </div>
                                        </template>

                                        <template #empty>
                                            No tasks found.
                                        </template>

                                        <template #loading>
                                            Loading tasks. Please wait.
                                        </template>

                                        <Column
                                            field="selectAnOption"
                                            header=""
                                            :headerStyle="{ width: '2rem' }"
                                            :bodyStyle="{ width: '2rem', padding: '0.25rem' }">
                                            <template #body="{ data, index }">
                                                <Button icon="pi pi-ellipsis-v" class="p-button-sm p-button-text p-button-rounded m-0"
                                                        @click="$refs['taskMenu' + index].toggle($event)"/>
                                                <Menu
                                                    :ref="'taskMenu' + index"
                                                    :model="getFilteredItems(data)"
                                                    :popup="true"/>
                                            </template>
                                        </Column>

                                        <Column v-for="column in columnsForDataTable" :key="column.field"
                                                :field="column.field"
                                                :sortable="column.sortable" :style="column.style"
                                                :frozen="column.frozen || false">

                                            <template #header>
                                            <span>
                                                {{ column.header }}
                                            </span>
                                            </template>

                                            <template #body="{ data }">
                                            <span v-if="column.field === 'status'">
                                                <span v-if="data[column.field] === 'A'"
                                                      :class="'status-badge status-' + data[column.field]">All</span>
                                                <span v-if="data[column.field] === 'I'"
                                                      :class="'status-badge status-' + data[column.field]">Initiated</span>
                                                <span v-if="data[column.field] === 'W'"
                                                      :class="'status-badge status-' + data[column.field]">Working On It</span>
                                                <span v-if="data[column.field] === 'T'"
                                                      :class="'status-badge status-' + data[column.field]">Ready for Testing</span>
                                                <span v-if="data[column.field] === 'C'"
                                                      :class="'status-badge status-' + data[column.field]">Completed</span>
                                                <span v-if="data[column.field] === 'R'"
                                                      :class="'status-badge status-' + data[column.field]">Rejected and Closed</span>
                                            </span>

                                                <span v-else-if="column.field === 'type'">
                                                <span v-if="data[column.field] === 'R'"
                                                      :class="'type-badge status-' + data[column.field]">Software Roadmap</span>
                                                <span v-if="data[column.field] === 'S'"
                                                      :class="'type-badge status-' + data[column.field]">Product Support</span>
                                                <span v-if="data[column.field] === 'B'"
                                                      :class="'type-badge status-' + data[column.field]">Billing</span>
                                                <span v-if="data[column.field] === 'C'"
                                                      :class="'type-badge status-' + data[column.field]">Client Management</span>
                                                <span v-if="data[column.field] === 'U'"
                                                      :class="'type-badge status-' + data[column.field]">Unpaids Management</span>
                                                <span v-if="data[column.field] === 'P'"
                                                      :class="'type-badge status-' + data[column.field]">Payment Management</span>
                                                <span v-if="data[column.field] === 'O'"
                                                      :class="'type-badge status-' + data[column.field]">Other</span>
                                                <span v-if="data[column.field] === 'D'"
                                                      :class="'type-badge status-' + data[column.field]">Administration</span>
                                                <span v-if="data[column.field] === 'E'"
                                                      :class="'type-badge status-' + data[column.field]">New Business</span>
                                                <span v-if="data[column.field] === 'F'"
                                                      :class="'type-badge status-' + data[column.field]">Financial Management</span>
                                                <span v-if="data[column.field] === 'G'"
                                                      :class="'type-badge status-' + data[column.field]">Authorisation</span>
                                                <span v-if="data[column.field] === 'H'"
                                                      :class="'type-badge status-' + data[column.field]">Claims</span>
                                                <span v-if="data[column.field] === 'M'"
                                                      :class="'type-badge status-' + data[column.field]">Marketing</span>
                                                <span v-if="data[column.field] === 'Q'"
                                                      :class="'type-badge status-' + data[column.field]">Benefit Query</span>
                                                <span v-if="data[column.field] === 'T'"
                                                      :class="'type-badge status-' + data[column.field]">Team Management</span>
                                            </span>

                                                <span v-else-if="column.field === 'category'">
                                                <span v-if="data[column.field] === 'I'"
                                                      :class="'type-badge status-' + data[column.field]">Improvement</span>
                                                <span v-if="data[column.field] === 'F'"
                                                      :class="'type-badge status-' + data[column.field]">Feature</span>
                                                <span v-if="data[column.field] === 'B'"
                                                      :class="'type-badge status-' + data[column.field]">Bug</span>
                                            </span>

                                                <span v-else-if="column.field === 'severity'">
                                                <span v-if="data[column.field] === 'M'"
                                                      :class="'type-badge status-' + data[column.field]">Major</span>
                                                <span v-if="data[column.field] === 'N'"
                                                      :class="'type-badge status-' + data[column.field]">Minor</span>
                                                <span v-if="data[column.field] === 'C'"
                                                      :class="'type-badge status-' + data[column.field]">Critical</span>
                                            </span>

                                                <span v-else-if="column.field === 'clientVisible'">
                                                <span v-if="data[column.field] === 'Y'"
                                                      :class="'confirmation-badge status-' + data[column.field]">Yes</span>
                                                <span v-if="data[column.field] === 'N'"
                                                      :class="'confirmation-badge status-' + data[column.field]">No</span>
                                            </span>

                                                <span v-else-if="column.field === 'created'">
                                                {{ convertDateIntoLocalTimezone(data["created"]) }}-->
                                            </span>

                                                <span v-else-if="column.field === 'max'">
                                                {{ formatTime(data["max"]) }}
                                            </span>

                                                <span v-else-if="column.field === 'elapsed'">
                                                {{ formatTime(calculateTimeDifference(data["start"])) }}
                                            </span>

                                                <span v-else-if="column.field === 'duration'">
                                                {{ formatTime(data["duration"]) }}
                                            </span>

                                                <span v-else-if="column.field === 'username'">
                                                {{ data["userFirstName"] + " " + data["userLastName"] }}
                                            </span>

                                                <span v-else-if="column.field === 'requesterName'">
                                                {{ data["requesterFirstName"] + " " + data["requesterLastName"] }}
                                            </span>

                                            <span v-else-if="column.field === 'due'">
                                                <i v-if="isOverdue(data)"
                                                   class="pi pi-exclamation-triangle text-red-500 mr-2"></i>
                                                <i v-else-if="isDueSoon(data)"
                                                   class="pi pi-clock text-orange-500 mr-2"></i>
                                                {{ data[column.field] }}
                                            </span>

                                            <span v-else-if="column.field === 'start'">
                                                <i v-if="isTimerStarted(data)" class="pi pi-spinner text-green-500 mr-2"></i>
                                                {{ data[column.field] }}
                                            </span>

                                            <span v-else>
                                                {{ data[column.field] }}
                                            </span>
                                            </template>
                                        </Column>

                                    </DataTable>

                                    <div class="scroll-help">
                                        ← Scroll sideways to see more columns →
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 3" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Task</h3>

                    <div class="field">
                        <label for="process">Process</label>
                        <AutoComplete placeholder="Search by name" :dropdown="false" :multiple="false"
                                      v-model="newTask.process" :suggestions="filteredProcesses"
                                      @complete="searchProcesses($event)" field="name"/>
                    </div>

                    <div class="field">
                        <label for="sprint">Sprint</label>
                        <AutoComplete placeholder="Search by name" :dropdown="false" :multiple="false"
                                      v-model="newTask.sprint" :suggestions="filteredSprints"
                                      @complete="searchSprints($event)" field="name"/>
                    </div>

                    <div v-show="companyConfiguration.type != 'F'" class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="newTask.type" :options="taskTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div v-show="companyConfiguration.type === 'F'" class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="newTask.type" :options="taskTypesFinancialAdvisor" optionLabel="name"
                                  optionValue="code" placeholder="Select a Type"/>
                    </div>

                    <div v-show="newTask.type === 'R'" class="field">
                        <label for="type">Severity</label>
                        <Dropdown v-model="newTask.severity" :options="severityTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Severity"/>
                    </div>

                    <div v-show="newTask.type === 'R'" class="field">
                        <label for="type">Category</label>
                        <Dropdown v-model="newTask.category" :options="categoryTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Category"/>
                    </div>

                    <div class="field">
                        <label for="priority">Priority</label>
                        <InputNumber id="priority" v-model="newTask.priority" :required="true"/>
                    </div>

                    <div class="field">
                        <label for="storyPoints">Story Points</label>
                        <Dropdown v-model="newTask.storyPoints" :options="storyPointsList" optionLabel="name"
                                  optionValue="code" placeholder="Select a Story Point"/>
                    </div>

                    <div class="field">
                        <label for="clientVisible">Client Visible?</label>
                        <Dropdown v-model="newTask.clientVisible" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="user">User</label>
                        <AutoComplete placeholder="Select by first name" :dropdown="false" :multiple="false"
                                      v-model="newTask.user" :suggestions="filteredUsers"
                                      @complete="searchUsers($event)"
                                      field="fullName"/>
                    </div>

                    <div class="field">
                        <label for="type">Do You Wish To Change the Requester?</label>
                        <Dropdown v-model="newTask.canChangeRequester" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-show="newTask.canChangeRequester === 'Y'" class="field">
                        <label for="user">Requester</label>
                        <AutoComplete placeholder="Select by first name" :dropdown="false" :multiple="false"
                                      v-model="newTask.requester" :suggestions="filteredUsers"
                                      @complete="searchUsers($event)"
                                      field="fullName"/>
                    </div>

                    <div class="field">
                        <label for="due">Due Date</label>
                        <Calendar id="due" v-model="newTask.due" required="true" :showTime="true" :showSeconds="false"
                                  :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="client">Client</label>
                        <AutoComplete placeholder="Search by name" :dropdown="false" :multiple="false"
                                      v-model="newTask.client" :suggestions="filteredClients"
                                      @complete="searchClients($event)"
                                      field="name"/>
                    </div>

                    <div v-if="newTask.description === ''" class="field">
                        <label for="description">Description</label>
                        <InputText id="description" v-model.trim="newTask.description" :required="true"
                                   class="p-invalid"/>
                        <InlineMessage>Field is required</InlineMessage>
                    </div>

                    <div v-if="newTask.description != ''" class="field">
                        <label for="description">Description</label>
                        <InputText id="description" v-model.trim="newTask.description" :required="true"/>
                    </div>

                    <div class="field">
                        <label for="max">Limit</label>
                        <InputText id="max" v-model="newTask.max" :required="true"/>
                    </div>

                    <div class="field">
                        <label for="note">Notes</label>
                        <Editor v-model="newTask.note" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" :loading="submitted" @click="createTask"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Task {{ this.task.description }}</h3>

                    <div class="field">
                        <label for="id">ID</label>
                        <InputText id="id" v-model="task.id" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="process">Process</label>
                        <AutoComplete placeholder="Search" :dropdown="false" :multiple="false"
                                      v-model="task.processName" :suggestions="filteredProcesses"
                                      @complete="searchProcesses($event)" field="name"/>
                    </div>

                    <div class="field">
                        <label for="sprint">Sprint</label>
                        <AutoComplete placeholder="Search" :dropdown="false" :multiple="false"
                                      v-model="task.sprintName" :suggestions="filteredSprints"
                                      @complete="searchSprints($event)" field="name"/>
                    </div>

                    <div v-show="companyConfiguration.type != 'F'" class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="task.type" :options="taskTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div v-show="companyConfiguration.type === 'F'" class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="task.type" :options="taskTypesFinancialAdvisor" optionLabel="name"
                                  optionValue="code" placeholder="Select a Type"/>
                    </div>

                    <div v-show="task.type === 'R'" class="field">
                        <label for="type">Severity</label>
                        <Dropdown v-model="task.severity" :options="severityTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Severity"/>
                    </div>

                    <div v-show="task.type === 'R'" class="field">
                        <label for="type">Category</label>
                        <Dropdown v-model="task.category" :options="categoryTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Category"/>
                    </div>

                    <div class="field">
                        <label for="priority">Priority</label>
                        <InputNumber id="priority" v-model="task.priority" :required="true"/>
                    </div>

                    <div class="field">
                        <label for="storyPoints">Story Points</label>
                        <Dropdown v-model="task.storyPoints" :options="storyPointsList" optionLabel="name"
                                  optionValue="code" placeholder="Select a Story Point"/>
                    </div>

                    <div class="field">
                        <label for="clientVisible">Client Visible?</label>
                        <Dropdown v-model="task.clientVisible" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="user">User</label>
                        <AutoComplete placeholder="Select by first name" :dropdown="false" :multiple="false"
                                      v-model="task.username" :suggestions="filteredUsers"
                                      @complete="searchUsers($event)"
                                      field="fullName"/>
                    </div>

                    <div class="field">
                        <label for="requester">Requester</label>
                        <InputText
                            id="requester"
                            :modelValue="requesterName"
                            disabled
                        />
                    </div>

                    <div class="field">
                        <label for="due">Due Date</label>
                        <Calendar id="due" v-model="parsedDue" required="true" :showTime="true" :showSeconds="false"
                                  :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="client">Client</label>
                        <AutoComplete placeholder="Search" :dropdown="true" :multiple="false" v-model="task.clientName"
                                      :suggestions="filteredClients" @complete="searchClients($event)" field="name"/>
                    </div>

                    <div class="field">
                        <label for="description">Description</label>
                        <InputText id="description" v-model.trim="task.description" required="true"/>
                    </div>

                    <div class="field">
                        <label for="note">Notes</label>
                        <Editor v-model="task.note" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="task.status" :options="statusTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted" @click="updateTask"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 5" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Complete Task {{ this.task.description }}</h3>

                    <div class="field">
                        <label for="deleteConfirmationResponse">Do You Wish to Complete this Task?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Complete" class="mr-2 mb-2" :loading="submitted" @click="completeTask"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 6" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Task {{ this.task.description }}</h3>

                    <div class="field">
                        <label for="deleteConfirmationResponse">Do You Wish to Delete this Task?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteTask"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 7" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>View Task {{ this.task.description }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Tasks</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="field">
                        <label for="id">ID</label>
                        <InputText id="id" v-model.trim="task.id" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="process">Process</label>
                        <InputText id="processName" v-model.trim="task.processName" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="sprint">Sprint</label>
                        <InputText id="sprintName" v-model.trim="task.sprintName" :disabled="true"/>
                    </div>

                    <div v-show="companyConfiguration.type != 'F'" class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="task.type" :options="taskTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div v-show="companyConfiguration.type === 'F'" class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="task.type" :options="taskTypesFinancialAdvisor" optionLabel="name"
                                  optionValue="code" placeholder="Select a Type"/>
                    </div>

                    <div v-show="task.type === 'R'" class="field">
                        <label for="type">Severity</label>
                        <Dropdown v-model="task.severity" :options="severityTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Severity"/>
                    </div>

                    <div v-show="task.type === 'R'" class="field">
                        <label for="type">Category</label>
                        <Dropdown v-model="task.category" :options="categoryTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Category"/>
                    </div>

                    <div class="field">
                        <label for="priority">Priority</label>
                        <InputNumber id="priority" v-model="task.priority" :required="true"/>
                    </div>

                    <div class="field">
                        <label for="storyPoints">Story Points</label>
                        <Dropdown v-model="task.storyPoints" :options="storyPointsList" optionLabel="name"
                                  optionValue="code" placeholder="Select a Story Point"/>
                    </div>

                    <div class="field">
                        <label for="clientVisible">Client Visible?</label>
                        <Dropdown :disabled="true" v-model="task.clientVisible" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="user">Assigned User</label>
                        <InputText id="username" v-model.trim="task.username" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="requester">Requester</label>
                        <InputText
                            id="requester"
                            :modelValue="requesterName"
                            disabled
                        />
                    </div>

                    <div class="field">
                        <label for="client">Client</label>
                        <InputText id="clientName" v-model.trim="task.clientName" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="description">Description</label>
                        <InputText id="description" v-model.trim="task.description" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="note">Notes</label>
                        <Editor :disabled="true" v-model="task.note" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown :disabled="true" v-model="task.status" :options="statusTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Status"/>
                    </div>

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 10" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Sprints</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callNewSprint" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>New Sprint</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Tasks</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="col-12 md:col-12">
                        <div class="card p-fluid">
                            <div class="p-grid">

                                <DataTable
                                    :value="sprints"
                                    lazy
                                    paginator
                                    :rows="lazyParamsSprints.rows"
                                    :first="lazyParamsSprints.first"
                                    :totalRecords="totalRecordsSprints"
                                    :loading="loading"
                                    :sortField="lazyParamsSprints.sortField"
                                    :sortOrder="lazyParamsSprints.sortOrder"
                                    :filterConstraints="lazyParamsSprints.filters"
                                    sortMode="single"
                                    :rowHover="true"
                                    :striped-rows="true"
                                    :reorderableColumns="true"
                                    filterDisplay="menu"
                                    responsiveLayout="scroll"
                                    :globalFilterFields="['id', 'name']"
                                    @page="onPageSprints"
                                    @sort="onSortSprints"
                                    @filter="onFilterSprints">

                                    <template #header>
                                        <div class="p-grid">
                                            <div class="grid">
                                                <div class="col-12 lg:col-3 p-2">
                                                    <Dropdown v-model="selectedSprintStatus"
                                                              :options="sprintStatus"
                                                              optionLabel="name" optionValue="code"
                                                              placeholder="Select a Status"
                                                              @update:modelValue="onToggleSprintStatus"/>
                                                </div>

                                                <div class="col-12 lg:col-6 p-2">
                                                    <span class="p-input-icon-left">
                                                        <i class="pi pi-search"/>
                                                        <InputText v-model="filtersSprints['global'].value"
                                                                   placeholder="Keyword Search on ID or Name (Please press enter to search)"
                                                                   style="width: 100%"
                                                                   @keyup.enter="onSearchSprints"/>

                                                    </span>
                                                </div>

                                                <div class="col-12 lg:col-3 p-2">
                                                    <Button type="button" icon="pi pi-filter-slash" label="Clear Search"
                                                            class="p-button-outlined p-ml-2" @click="clearFilter()"/>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <template #empty>
                                        No sprints found.
                                    </template>

                                    <template #loading>
                                        Loading sprints. Please wait.
                                    </template>

                                    <Column header="Actions" :exportable="false"
                                            style="max-width: 130px; min-width: 100px;">
                                        <template #body="{ data }">
                                            <div
                                                style="max-width: 130px; min-width: 100px; display: flex; flex-wrap: wrap; justify-content: flex-start; align-items: center;">

                                                <Button v-if="data['status'] != 'C'" v-tooltip.top="'Update'"
                                                        icon="pi pi-pencil"
                                                        class="p-button-rounded p-button-success m-1"
                                                        :loading="submitted"
                                                        @click="callUpdateSprint(data)"/>

                                                <Button v-if="data['status'] != 'C'" v-tooltip.top="'Delete'"
                                                        icon="pi pi-trash"
                                                        class="p-button-rounded p-button-danger m-1"
                                                        :loading="submitted"
                                                        @click="callDeleteSprint(data)"/>

                                                <Button v-if="data['status'] === 'C'" v-tooltip.top="'View'"
                                                        icon="pi pi-eye"
                                                        class="p-button-rounded p-button-info m-1"
                                                        :loading="submitted"
                                                        @click="callViewSprint(data)"/>

                                            </div>
                                        </template>
                                    </Column>

                                    <Column v-for="column in columnsSprintList" :key="column.field"
                                            :field="column.field"
                                            :sortable="column.sortable" :style="column.style"
                                            :frozen="column.frozen || false">

                                        <template #header>
                                            <span>
                                                {{ column.header }}
                                            </span>
                                        </template>

                                        <template #body="{ data }">
                                            <span v-if="column.field === 'status'">
                                                <span v-if="data[column.field] === 'I'"
                                                      :class="'status-badge status-' + data[column.field]">Initiated</span>
                                                <span v-if="data[column.field] === 'S'"
                                                      :class="'status-badge status-' + data[column.field]">Started</span>
                                                <span v-if="data[column.field] === 'C'"
                                                      :class="'status-badge status-' + data[column.field]">Completed</span>
                                            </span>

                                            <span v-else-if="column.field === 'start'">
                                                {{ convertDateIntoLocalTimezoneFormat1(data["start"]) }}
                                            </span>

                                            <span v-else-if="column.field === 'end'">
                                                <span v-if="data[column.field] !== null && data[column.field] !== undefined
                                                && data[column.field] !== ''">
                                                    {{ convertDateIntoLocalTimezoneFormat1(data[column.field]) }}
                                                </span>
                                                <span v-else>
                                                    N/A
                                                </span>
                                            </span>

                                            <span v-else>
                                                {{ data[column.field] }}
                                            </span>
                                        </template>
                                    </Column>

                                </DataTable>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 11" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Sprint</h3>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="newSprint.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="due">Start Date</label>
                        <Calendar id="due" v-model="newSprint.start" required="true" :showTime="true"
                                  :showSeconds="false"
                                  :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="note">Description</label>
                        <Textarea v-model.trim="newSprint.description" :autoResize="true" rows="5" cols="30"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" :loading="submitted" @click="createSprint"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetSprint"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 12" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Sprint {{ this.sprint.name }}</h3>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="sprint.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="due">Start Date</label>
                        <Calendar id="due" v-model="sprint.start" required="true" :showTime="true" :showSeconds="false"
                                  :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="due">Completed Date</label>
                        <Calendar id="due" v-model="sprint.end" required="true" :showTime="true" :showSeconds="false"
                                  :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="note">Description</label>
                        <Textarea v-model.trim="sprint.description" :autoResize="true" rows="5" cols="30"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="sprint.status" :options="sprintStatusLimited" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted" @click="updateSprint"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetSprint"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 13" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Sprint {{ this.sprint.name }}</h3>

                    <div class="field">
                        <label for="deleteConfirmationResponse">Do You Wish to Delete this Sprint?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteSprint"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetSprint"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 14" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>View Sprint {{ this.sprint.name }}</h3>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="sprint.name" required="true" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="due">Start Date</label>
                        <Calendar id="due" v-model="sprint.start" required="true" :showTime="true" :showSeconds="false"
                                  :showIcon="true" dateFormat="yy-mm-dd" :disabled="true"/>

                    </div>

                    <div class="field">
                        <label for="due">Completed Date</label>
                        <Calendar id="due" v-model="sprint.end" required="true" :showTime="true" :showSeconds="false"
                                  :showIcon="true" dateFormat="yy-mm-dd" :disabled="true"/>

                    </div>

                    <div class="field">
                        <label for="note">Description</label>
                        <Textarea v-model.trim="sprint.description" :autoResize="true" rows="5" cols="30"
                                  :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="sprint.status" :options="sprintStatus" optionLabel="name" optionValue="code"
                                  placeholder="Select a Status" :disabled="true"/>
                    </div>

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetSprint"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 15" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Send Email to Client {{ this.task.clientName }}</h3>

                    <div class="field">
                        <label for="emailSubject">Email Subject</label>
                        <InputText id="emailSubject" v-model.trim="email.emailSubject" required="true"/>
                    </div>

                    <div class="field">
                        <label for="emailMessage">Email Message</label>
                        <Editor v-model="email.emailMessage" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div style="height: 15px;"></div>

                    <div class="p-field">
                        <label for="file">File Attachment</label>
                        <div style="height: 10px;"></div>
                        <input
                            type="file"
                            ref="fileInput"
                            @change="handleEmailFileUpload"
                            accept="application/pdf"/>
                    </div>

                    <div style="height: 15px;"></div>

                    <Button label="Send" class="mr-2 mb-2" :loading="submitted" @click="sendEmail"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 16" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Send SMS to Client {{ this.task.clientName }}</h3>

                    <div class="field">
                        <label for="smsMessage">SMS Message</label>
                        <InputText id="smsMessage" v-model.trim="sms.smsMessage" required="true"/>
                    </div>

                    <Button label="Send" class="mr-2 mb-2" :loading="submitted" @click="sendSms"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 17" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Files</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callUploadFile" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Upload File</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callAddExternalFile" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Add External File</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Overview</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="col-12 md:col-12">
                        <div class="card p-fluid">
                            <div class="p-grid">

                                <div class="datatable-scroll-container">

                                    <DataTable
                                        :value="taskFiles"
                                        :paginator="true"
                                        class="p-datatable-gridlines"
                                        :rows="100"
                                        dataKey="id"
                                        :rowsPerPageOptions="[10,20,50,100]"
                                        :rowHover="true"
                                        :striped-rows="true"
                                        :reorderableColumns="true"
                                        :sortMode="'multiple'"
                                        v-model:filters="filtersForFiles"
                                        filterDisplay="menu"
                                        :loading="submitted"
                                        :tableStyle="{ minWidth: '100%' }"
                                        responsiveLayout="scroll"
                                        :globalFilterFields="['simpleFilename']">

                                        <template #empty>
                                            No files found.
                                        </template>

                                        <template #loading>
                                            Loading files. Please wait.
                                        </template>

                                        <Column
                                            field="selectAnOption"
                                            header=""
                                            :headerStyle="{ width: '2rem' }"
                                            :bodyStyle="{ width: '2rem', padding: '0.25rem' }">
                                            <template #body="{ data, index }">
                                                <Button icon="pi pi-ellipsis-v" class="p-button-sm p-button-text p-button-rounded m-0"
                                                        @click="$refs['filesMenu' + index].toggle($event)"/>
                                                <Menu
                                                    :ref="'filesMenu' + index"
                                                    :model="getFilteredItemsForFiles(data)"
                                                    :popup="true"/>
                                            </template>
                                        </Column>

                                        <Column field="type" header="Type" :sortable="true">
                                            <template #body="{ data }">
                                <span v-if="data.type === 'G'"
                                      :class="'type-badge status-' + data.type">General</span>
                                                <span v-if="data.type === 'C'"
                                                      :class="'type-badge status-' + data.type">Client</span>
                                                <span v-if="data.type === 'N'"
                                                      :class="'type-badge status-' + data.type">Note</span>
                                                <span v-if="data.type === 'F'"
                                                      :class="'type-badge status-' + data.type">Financial</span>
                                                <span v-if="data.type === 'T'"
                                                      :class="'type-badge status-' + data.type">Task</span>
                                            </template>
                                        </Column>

                                        <Column field="provider" header="Provider" :sortable="true">
                                            <template #body="{ data }">
                                                <span class="p-column-title">Provider</span>
                                                <span v-if="data.provider === 'E'"
                                                      :class="'type-badge status-' + data.provider">External</span>
                                                <span v-else
                                                      :class="'type-badge status-' + data.provider">Internal</span>
                                            </template>
                                        </Column>

                                        <Column field="simpleFilename" header="File Name" :sortable="true">
                                            <template #body="{ data }">
                                                <span class="p-column-title">File Name</span>
                                                {{ data.simpleFilename }}
                                            </template>
                                        </Column>

                                        <Column field="created" header="Created" :sortable="true">
                                            <template #body="{ data }">
                                                <span class="p-column-title">Created</span>
                                                {{ formatDate(data.created) }}
                                            </template>
                                        </Column>

                                    </DataTable>

                                    <div class="scroll-help">
                                        ← Scroll sideways to see more columns →
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 18" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Upload File</h3>

                    <div class="p-field">
                        <input
                            type="file"
                            ref="fileInput"
                            @change="handleFileUpload"
                            accept="application/pdf,image/png,image/jpeg"/>
                    </div>

                    <br/>

                    <div class="p-field">
                        <Button label="Upload" class="mr-2 mb-2" :disabled="!file"
                                @click="uploadFile"></Button>
                    </div>

                    <br/>
                    <div class="p-field">
                        <Button label="Cancel" class="mr-2 mb-2" :loading="submitted"
                                @click="callResetUploadFiles"></Button>
                    </div>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 19" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete File {{ this.specificFile.simpleFilename }}</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this File?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>


                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteFile"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetUploadFiles"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 20" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Add External File</h3>

                    <div class="field">
                        <label for="externalFilename">External Filename</label>
                        <InputText id="externalFilename" v-model.trim="externalFilename" required="true"/>
                    </div>

                    <div class="field">
                        <label for="externalLink">Full Link to External File</label>
                        <InputText id="externalLink" v-model.trim="externalLink" required="true"/>
                    </div>

                    <Button label="Add File" class="mr-2 mb-2" :loading="submitted" @click="addExternalFile"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetUploadFiles"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 21" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update File</h3>

                    <div class="field">
                        <label for="externalFilename">Filename</label>
                        <InputText id="externalFilename" v-model.trim="specificFile.simpleFilename" required="true"/>
                    </div>

                    <Button label="Update File" class="mr-2 mb-2" :loading="submitted" @click="updateFile"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetUploadFiles"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 22" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update External File</h3>

                    <div class="field">
                        <label for="externalFilename">External Filename</label>
                        <InputText id="externalFilename" v-model.trim="specificFile.simpleFilename" required="true"/>
                    </div>

                    <div class="field">
                        <label for="externalLink">Full Link to External File</label>
                        <InputText id="externalLink" v-model.trim="specificFile.filename" required="true"/>
                    </div>

                    <Button label="Update File" class="mr-2 mb-2" :loading="submitted" @click="updateFile"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetUploadFiles"></Button>

                </div>
            </div>
        </div>


    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import CompanyService from "@/service/CompanyService";
import TaskService from "@/service/TaskService";
import numeral from "numeral";
import ProcessService from "@/service/ProcessService";
import ClientService from "@/service/ClientService";
import moment from "moment";
import SprintService from "@/service/SprintService";
import StorageService from "@/service/StorageService";
import axios from "axios";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();
    },
    async mounted() {
        try {
            await UserService.getUserPing();
        } catch (e) {
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        await this.loadCompanyContext();
    },
    data() {

        return {
            file: null,
            fileClientImport: null,
            taskFiles: null,
            specificFile: {},
            externalFilename: null,
            externalLink: null,
            filtersForFiles: null,
            selectedClientFileType: 'T',
            totalRecords: 0,
            totalRecordsSprints: 0,
            loading: false,
            lazyParams: {
                first: 0,
                rows: 100,
                sortField: null,
                sortOrder: null,
                status: {},
                type: {},
                category: {},
                filter: {}
            },
            lazyParamsSprints: {
                first: 0,
                rows: 20,
                sortField: null,
                sortOrder: null,
                status: {}
            },
            profile: {},
            activeTab: 1,
            companyConfiguration: {},
            userConfiguration: {},
            filters: null,
            filtersSprints: null,
            submitted: false,
            task: {},
            newTask: {},
            tasks: null,
            sprints: null,
            sprint: {},
            newSprint: {},
            email: {},
            sms: {},
            originalTasks: null,
            confirmationResponse: 'N',
            selectedColumns: [],
            sprintStatus: [
                {name: 'All', code: 'A'},
                {name: 'Initiated', code: 'I'},
                {name: 'Started', code: 'S'},
                {name: 'Completed', code: 'C'}
            ],
            sprintStatusLimited: [
                {name: 'Initiated', code: 'I'},
                {name: 'Started', code: 'S'},
                {name: 'Completed', code: 'C'}
            ],
            standardStatus: [
                {name: 'All', code: 'A'},
                {name: 'Initiated', code: 'I'},
                {name: 'Working On It', code: 'W'},
                {name: 'Ready for Testing', code: 'T'},
                {name: 'Completed', code: 'C'},
                {name: 'Rejected and Closed', code: 'R'}
            ],
            standardTypes: [
                {name: 'Software Roadmap', code: 'R'},
                {name: 'Product Support', code: 'S'},
                {name: 'Billing', code: 'B'},
                {name: 'Client Management', code: 'C'},
                {name: 'Unpaids Management', code: 'U'},
                {name: 'Payment Management', code: 'P'},
                {name: 'Administration', code: 'D'},
                {name: 'Financial Management', code: 'F'},
                {name: 'Marketing', code: 'M'},
                {name: 'Other', code: 'O'}
            ],
            standardCategories: [
                {name: 'Feature', code: 'F'},
                {name: 'Improvement', code: 'I'},
                {name: 'Bug', code: 'B'}
            ],
            standardFilters: [
                {name: '<No Filter>', code: 'N'},
                {name: 'My Tasks', code: 'M'},
                {name: 'All Active Tasks', code: 'A'},
                {name: 'Last 7 Days', code: 'W'}
            ],
            selectedStatus: null,
            selectedSprintStatus: null,
            selectedType: null,
            selectedCategory: null,
            selectedFilter: null,
            selectedFormat: "Minimal",
            filteredProcesses: [],
            filteredSprints: [],
            filteredClients: [],
            filteredUsers: [],
            formats: [
                {name: 'Minimal View', code: 'Minimal'},
                {name: 'Extended View', code: 'Extended'}
            ],
            storyPointsList: [
                {name: '1', code: 1},
                {name: '2', code: 2},
                {name: '3', code: 3},
                {name: '5', code: 5},
                {name: '8', code: 8},
                {name: '13', code: 13},
                {name: '21', code: 21},
                {name: '34', code: 34},
            ],
            statusTypes: [
                {name: 'Initiated', code: 'I'},
                {name: 'Working On It', code: 'W'},
                {name: 'Ready for Testing', code: 'T'},
                {name: 'Completed', code: 'C'},
                {name: 'Rejected and Closed', code: 'R'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            taskTypes: [
                {name: 'Software Roadmap', code: 'R'},
                {name: 'Product Support', code: 'S'},
                {name: 'Billing', code: 'B'},
                {name: 'Client Management', code: 'C'},
                {name: 'Unpaids Management', code: 'U'},
                {name: 'Payment Management', code: 'P'},
                {name: 'Administration', code: 'D'},
                {name: 'Financial Management', code: 'F'},
                {name: 'Marketing', code: 'M'},
                {name: 'Other', code: 'O'}
            ],
            severityTypes: [
                {name: 'Major', code: 'M'},
                {name: 'Minor', code: 'N'},
                {name: 'Critical', code: 'C'}
            ],
            categoryTypes: [
                {name: 'Feature', code: 'F'},
                {name: 'Improvement', code: 'I'},
                {name: 'Bug', code: 'B'}
            ],
            taskTypesFinancialAdvisor: [
                {name: 'Administration', code: 'D'},
                {name: 'New Business', code: 'E'},
                {name: 'Benefit Query', code: 'Q'},
                {name: 'Authorisation', code: 'G'},
                {name: 'Claims', code: 'H'},
                {name: 'Software Roadmap', code: 'R'},
                {name: 'Product Support', code: 'S'},
                {name: 'Billing', code: 'B'},
                {name: 'Scheduling', code: 'C'},
                {name: 'Unpaids Management', code: 'U'},
                {name: 'Payment Management', code: 'P'},
                {name: 'Administration', code: 'D'},
                {name: 'Financial Management', code: 'F'},
                {name: 'Marketing', code: 'M'},
                {name: 'Other', code: 'O'}
            ],
            columnsFullList: [
                {field: 'id', header: 'ID', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {
                    field: 'processName',
                    header: 'Process Name',
                    sortable: true,
                    style: 'max-width: 250px; min-width: 200px'
                },
                {
                    field: 'clientName',
                    header: 'Client Name',
                    sortable: true,
                    style: 'max-width: 250px; min-width: 200px'
                },
                {
                    field: 'sprintName',
                    header: 'Sprint Name',
                    sortable: true,
                    style: 'max-width: 250px; min-width: 200px'
                },
                {field: 'status', header: 'Status', sortable: true, style: 'max-width: 200px; min-width: 150px'},
                {field: 'type', header: 'Type', sortable: true, style: 'max-width: 300px; min-width: 250px'},
                {field: 'severity', header: 'Severity', sortable: true, style: 'max-width: 200px; min-width: 150px'},
                {field: 'category', header: 'Category', sortable: true, style: 'max-width: 250px; min-width: 200px'},
                {field: 'priority', header: 'Priority', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {
                    field: 'storyPoints',
                    header: 'Story Points',
                    sortable: true,
                    style: 'max-width: 100px; min-width: 50px'
                },
                {
                    field: 'description',
                    header: 'Description',
                    sortable: true,
                    style: 'max-width: 400px; min-width: 300px'
                },
                {
                    field: 'clientVisible',
                    header: 'Client Visible?',
                    sortable: true,
                    style: 'max-width: 100px; min-width: 50px'
                },
                {
                    field: 'username',
                    header: 'Assigned User',
                    sortable: true,
                    style: 'max-width: 150px; min-width: 100px'
                },
                {
                    field: 'requesterName',
                    header: 'Requester Name',
                    sortable: true,
                    style: 'max-width: 150px; min-width: 100px'
                },
                {field: 'start', header: 'Start Date', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'due', header: 'Due Date', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'end', header: 'End Date', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'max', header: 'Max Duration', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'elapsed', header: 'Elapsed Time', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'duration', header: 'Duration', sortable: true, style: 'max-width: 100px; min-width: 50px'},
            ],
            columnsMinimalList: [
                {field: 'id', header: 'ID', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {
                    field: 'processName',
                    header: 'Process Name',
                    sortable: true,
                    style: 'max-width: 250px; min-width: 200px'
                },
                {
                    field: 'clientName',
                    header: 'Client Name',
                    sortable: true,
                    style: 'max-width: 250px; min-width: 200px'
                },
                {field: 'status', header: 'Status', sortable: true, style: 'max-width: 200px; min-width: 150px'},
                {field: 'type', header: 'Type', sortable: true, style: 'max-width: 300px; min-width: 250px'},
                {field: 'priority', header: 'Priority', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {
                    field: 'description',
                    header: 'Description',
                    sortable: true,
                    style: 'max-width: 400px; min-width: 300px'
                },
                {
                    field: 'username',
                    header: 'Assigned User',
                    sortable: true,
                    style: 'max-width: 150px; min-width: 100px'
                },
                {
                    field: 'requesterName',
                    header: 'Requester Name',
                    sortable: true,
                    style: 'max-width: 150px; min-width: 100px'
                },
                {field: 'start', header: 'Start Date', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'due', header: 'Due Date', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'end', header: 'End Date', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'elapsed', header: 'Elapsed Time', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'duration', header: 'Duration', sortable: true, style: 'max-width: 100px; min-width: 50px'},
            ],
            columnsMinimalListFinancialAdvisor: [
                {field: 'id', header: 'ID', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {
                    field: 'processName',
                    header: 'Process Name',
                    sortable: true,
                    style: 'max-width: 250px; min-width: 200px'
                },
                {
                    field: 'clientName',
                    header: 'Client Name',
                    sortable: true,
                    style: 'max-width: 250px; min-width: 200px'
                },
                {field: 'status', header: 'Status', sortable: true, style: 'max-width: 200px; min-width: 150px'},
                {field: 'type', header: 'Type', sortable: true, style: 'max-width: 300px; min-width: 250px'},
                {field: 'priority', header: 'Priority', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {
                    field: 'description',
                    header: 'Description',
                    sortable: true,
                    style: 'max-width: 400px; min-width: 300px'
                },
                {
                    field: 'username',
                    header: 'Assigned User',
                    sortable: true,
                    style: 'max-width: 150px; min-width: 100px'
                },
                {
                    field: 'requesterName',
                    header: 'Requester Name',
                    sortable: true,
                    style: 'max-width: 150px; min-width: 100px'
                },
                {field: 'start', header: 'Start Date', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'due', header: 'Due Date', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'end', header: 'End Date', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'elapsed', header: 'Elapsed Time', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'duration', header: 'Duration', sortable: true, style: 'max-width: 100px; min-width: 50px'},
            ],
            columnsSprintList: [
                {
                    field: 'name',
                    header: 'Sprint Name',
                    sortable: true,
                    style: 'max-width: 120px; min-width: 50px'
                },
                {field: 'status', header: 'Status', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'start', header: 'Start Date', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'end', header: 'Completed Date', sortable: true, style: 'max-width: 100px; min-width: 50px'},
            ],
        }
    },
    watch: {
        '$route.query.tab'(newVal) {
            if (newVal === "1") {
                this.activeTab = 1;
                this.$router.replace({path: this.$route.path});
            } else if (newVal === "2") {
                this.callNewAuditTrail();
                this.$router.replace({path: this.$route.path});
            } else if (newVal === "3") {
                this.callNewSprint();
                this.$router.replace({path: this.$route.path});
            }
        },
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                await this.loadCompanyContext();
            }
        }
    },
    computed: {
        parsedDue: {
            get() {
                return new Date(this.task.due);
            },
            set(value) {
                this.task.due = value instanceof Date ? value.toISOString() : '';
            }
        },
        columnsForDataTable() {
            if (!this.selectedColumns || !Array.isArray(this.selectedColumns)) {
                return [];
            }

            const columnsMap = new Map(this.columnsFullList.map(column => [column.field, column]));
            return this.selectedColumns.map(field => columnsMap.get(field)).filter(Boolean);
        },
        requesterName() {
            return `${this.task.requesterFirstName || ''} ${this.task.requesterLastName || ''}`.trim();
        }
    },
    methods: {
        isDueSoon(data) {
            if (!data.due || data.status === 'C') return false;

            const dueDate = this.parseDateTime(data.due);
            const now = new Date();

            const diffHours = (dueDate - now) / (1000 * 60 * 60);

            return diffHours > 0 && diffHours <= 24; // next 24 hours
        },
        isOverdue(data) {
            if (!data.due || data.status === 'C') {
                return false;
            }

            const dueDate = this.parseDateTime(data.due);
            return dueDate && new Date() > dueDate;
        },
        isTimerStarted(data) {
            if ( (data.startTimer !== null) && (data.endTimer === null)) {
                return true
            }
        },
        rowClass(data) {
            if (this.isOverdue(data)) return 'row-overdue';
            if (this.isDueSoon(data)) return 'row-due-soon';

            return '';
        },
        parseDateTime(value) {
            // Converts "2026-03-21 00:00" to "2026-03-21T00:00:00"
            const isoValue = value.replace(' ', 'T');

            return new Date(isoValue.length === 16 ? isoValue + ':00' : isoValue);
        },
        formatDate(inputDate) {

            if (!inputDate) {
                return "";
            }

            const converted = this.convertDateIntoLocalTimezone(inputDate);
            const date = new Date(converted);

            if (isNaN(date.getTime())) {
                return "";
            }

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

            return formattedDate;
        },
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            const [userConfigurationData, companyConfigurationData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id),
                CompanyService.getCompanyConfiguration(this.profile.companyId)
            ]);

            this.userConfiguration = userConfigurationData.data;
            this.companyConfiguration = companyConfigurationData.data;

            this.selectedStatus = "A";
            this.selectedFilter = "M";

            await this.loadData();

            if (this.$route.query.tab === "1") {
                this.activeTab = 1;
                this.$router.replace({path: this.$route.path});
            }

            if (this.$route.query.tab === "2") {
                this.callNewTask();
                this.$router.replace({path: this.$route.path});
            }

            if (this.$route.query.tab === "3") {
                this.callNewSprint();
                this.$router.replace({path: this.$route.path});
            }

            this.loading = false;

            if (this.companyConfiguration.type === 'F') {
                this.selectedColumns = this.columnsMinimalListFinancialAdvisor.map(column => column.field);
            } else {
                this.selectedColumns = this.columnsMinimalList.map(column => column.field);
            }
        },
        async loadData() {
            this.loading = true;
            try {
                if (this.selectedFilter === 'N') {
                    this.selectedFilter = null;
                }

                const response = await TaskService.getCompanyTasksLazyLoading(
                    this.profile.companyId,
                    this.userStore.user.id,
                    this.lazyParams,
                    this.filters['global']?.value || '',
                    this.selectedStatus,
                    this.selectedType,
                    this.selectedCategory,
                    this.selectedFilter,
                    null, null);

                const data = Array.isArray(response.data.content)
                    ? response.data.content
                    : [];

                this.tasks = data;
                this.originalTasks = [...data];
                this.totalRecords = response.data?.totalElements || 0;

                console.debug("[loadData] this.tasks = ", this.tasks)

            } catch (error) {
                this.tasks = [];
                this.originalTasks = [];
                this.totalRecords = 0;
            }
            this.loading = false;
        },
        async loadSprints() {
            this.loading = true;
            try {
                const response = await SprintService.getCompanySprints(
                    this.profile.companyId,
                    this.lazyParamsSprints,
                    this.filtersSprints['global']?.value || '',
                    this.selectedSprintStatus,
                    null, null);

                this.sprints = Array.isArray(response.data.content) ? response.data.content : [];

                this.totalRecords = response.data?.totalElements || 0;

            } catch (error) {
                this.sprints = [];
                this.totalRecords = 0;
            }
            this.loading = false;
        },
        onPage(event) {
            this.lazyParams.first = event.first;
            this.lazyParams.rows = event.rows;
            this.loadData();
        },
        onSort(event) {
            if (event.sortField) {
                this.lazyParams.sortField = event.sortField;
                this.lazyParams.sortOrder = event.sortOrder;
            } else {
                this.lazyParams.sortField = null;
                this.lazyParams.sortOrder = null;
            }
            this.loadData();
        },
        onFilter(event) {
            this.lazyParams.filters = event.filters;
            this.loadData();
        },
        onSearch() {
            this.lazyParams.first = 0;
            this.loadData();
        },
        onPageSprints(event) {
            this.lazyParamsSprints.first = event.first;
            this.lazyParamsSprints.rows = event.rows;
            this.loadSprints();
        },
        onSortSprints(event) {
            if (event.sortField) {
                this.lazyParamsSprints.sortField = event.sortField;
                this.lazyParamsSprints.sortOrder = event.sortOrder;
            } else {
                this.lazyParamsSprints.sortField = null;
                this.lazyParamsSprints.sortOrder = null;
            }
            this.loadSprints();
        },
        onFilterSprints(event) {
            this.lazyParamsSprints.filters = event.filters;
            this.loadSprints();
        },
        onSearchSprints() {
            this.lazyParamsSprints.first = 0;
            this.loadSprints();
        },
        async onToggleStatus() {
            await this.loadData();
        },
        async onToggleSprintStatus() {
            await this.loadSprints();
        },
        async onToggleTypes() {
            await this.loadData();
        },
        async onToggleCategories() {
            await this.loadData();
        },
        async onToggleFilters() {
            await this.loadData();
        },
        onFormatChange() {
            if (this.selectedFormat === "Minimal") {
                if (this.companyConfiguration.type === 'F') {
                    this.selectedColumns = this.columnsMinimalListFinancialAdvisor.map(column => column.field);
                } else {
                    this.selectedColumns = this.columnsMinimalList.map(column => column.field);
                }

            } else {
                this.selectedColumns = this.columnsFullList.map(column => column.field);
            }
        },
        clearFilter() {
            // this.initFilters();
            this.selectedStatus = "I";
            this.selectedType = null;
            this.selectedCategory = null;
            this.selectedFilter = null;
            // this.filters = null;
            this.lazyParams.filters = {};
            this.lazyParams.first = 0;
            this.loadData();
        },
        async restoreToOriginal() {
            this.$router.go(0);
        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'id': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'processName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'sprintName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'description': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'username': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'clientName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'end': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }

            this.filtersSprints = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'id': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'name': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }

            this.filtersForFiles = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'simpleFilename': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        callReset() {
            this.activeTab = 1;
        },
        callResetSprint() {
            this.activeTab = 10;
        },
        callResetUploadFiles() {
            this.activeTab = 17;
        },
        callManageSprints() {
            this.activeTab = 10;
            this.selectedSprintStatus = 'A';
            this.loadSprints();
        },
        callNewTask() {
            if (this.companyConfiguration.type === 'S') {
                this.newTask = {
                    type: 'R',
                    severity: 'N',
                    category: 'F',
                    priority: 1,
                    storyPoints: 1,
                    clientVisible: 'N',
                    canChangeRequester: 'N',
                    due: moment().add(5, 'days').startOf('hour').toDate()
                };

            } else {
                this.newTask = {
                    type: 'D',
                    severity: 'N',
                    category: 'F',
                    priority: 1,
                    storyPoints: 1,
                    clientVisible: 'N',
                    canChangeRequester: 'N',
                    due: moment().add(5, 'days').startOf('hour').toDate()
                };

            }
            this.activeTab = 3;
            this.$router.replace({path: this.$route.path});
        },
        async callActiveTasks() {
            const [taskData] = await Promise.all([
                TaskService.getCompanyActiveTasks(this.profile.companyId)
            ]);

            this.tasks = taskData.data;
            this.originalTasks = taskData.data;
            this.userStore.setTasks(taskData.data)

            this.loading = false;

            this.activeTab = 1;
        },
        callUpdateTask(data) {
            this.activeTab = 4;
            this.task = data;
        },
        callCompleteTask(data) {
            this.activeTab = 5;
            this.confirmationResponse = 'N';
            this.task = data;
        },
        callDeleteTask(data) {
            this.activeTab = 6;
            this.confirmationResponse = 'N';
            this.task = data;
        },
        callViewTask(data) {
            this.activeTab = 7;
            this.task = data;
        },
        async callManageFiles(data) {
            this.activeTab = 17;
            this.submitted = true;
            this.task = data;

            console.log("[Tasks][callManageFiles] this.task = ", this.task);

            try {
                const [taskFilesData] = await Promise.all([
                    StorageService.getCompanyStorageForTask(this.profile.companyId, this.task.id),
                ]);

                this.taskFiles = taskFilesData.data;
                console.log("[Tasks][callManageFiles] this.taskFiles = ", this.taskFiles);

                this.submitted = false;

            } catch (e) {
                console.error("[Tasks][callManageFiles] Error fetching additional data = ", e);
            }

            this.submitted = false;

            console.log("[Tasks][callManageFiles] this.taskFiles = ", this.taskFiles);
        },
        callUploadFile() {
            console.log("[Tasks][callUploadFile] this.task = ", this.task);
            this.activeTab = 18;
            this.selectedFileType = 'T';
        },
        callAddExternalFile() {
            console.log("[Tasks][callAddExternalFile] this.task = ", this.task);
            this.externalFilename = null;
            this.externalLink = null;
            this.activeTab = 20;
            this.selectedFileType = 'T';
        },
        callDeleteFile(data) {
            this.activeTab = 19;
            this.confirmationResponse = 'N';
            this.specificFile = data;
        },
        async callUpdateFile(data) {
            this.activeTab = 21;
            this.specificFile = data;
        },
        async callUpdateExternalFile(data) {
            this.activeTab = 22;
            this.specificFile = data;
        },
        callSendEmail(data) {
            this.activeTab = 15;
            this.task = data;
        },
        callSendSms(data) {
            this.activeTab = 16;
            this.task = data;
        },
        callNewSprint() {
            this.newSprint = {
                status: 'I',
                start: moment().startOf('hour').toDate()
            };

            this.activeTab = 11;
            this.$router.replace({path: this.$route.path});
        },
        callUpdateSprint(data) {
            this.activeTab = 12;
            this.sprint = data;
        },
        callDeleteSprint(data) {
            this.activeTab = 13;
            this.confirmationResponse = 'N';
            this.sprint = data;
        },
        callViewSprint(data) {
            this.activeTab = 14;
            this.sprint = data;
        },
        onToggleColumns(event) {
            this.selectedColumns = event.value;
        },
        getFilteredItems(data) {
            const items = [];

            items.push({
                label: 'View',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callViewTask(data);
                }
            });

            items.push({
                label: 'Manage Files',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callManageFiles(data);
                }
            });

            if (data.status !== 'C') {
                items.push({
                    label: 'Update',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callUpdateTask(data);
                    }
                });

                items.push({
                    label: 'Complete',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callCompleteTask(data);
                    }
                });

                items.push({
                    label: 'Delete',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callDeleteTask(data);
                    }
                });
            }

            if ( (data.status !== 'C') && (data.startTimer === null)) {
                items.push({
                    label: 'Start Timer',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.playTask(data);
                    }
                });
            }

            if ( (data.status !== 'C') && (data.startTimer !== null)) {
                items.push({
                    label: 'Stop Timer',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.endTask(data);
                    }
                });
            }

            if (data.clientId !== null) {
                items.push({
                    label: 'Send Email',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callSendEmail(data);
                    }
                });

                items.push({
                    label: 'Send SMS',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callSendSms(data);
                    }
                });
            }

            return items;
        },
        getFilteredItemsForFiles(data) {

            const items = [];

            if (data.provider === 'E') {
                items.push({
                    label: 'Update',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callUpdateExternalFile(data);
                    }
                });

                items.push({
                    label: 'View',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.viewExternalFile(data);
                    }
                });

                items.push({
                    label: 'Delete',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callDeleteFile(data);
                    }
                });

            } else {
                items.push({
                    label: 'Update',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callUpdateFile(data);
                    }
                });

                items.push({
                    label: 'View',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.viewFile(data);
                    }
                });

                items.push({
                    label: 'Download',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.downloadFile(data);
                    }
                });

                items.push({
                    label: 'Delete',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callDeleteFile(data);
                    }
                });
            }

            return items;
        },
        chooseBlankSelection() {
            this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please select a valid option.',
                life: 3000
            });
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            }
        },
        calculateTimeDifference(startTime) {
            if (!startTime) {
                return 0;
            }

            const targetDate = new Date(startTime);

            if (isNaN(targetDate.getTime())) {
                return 0;
            }

            const currentDate = new Date();

            const timeDifferenceMs = currentDate - targetDate;

            return timeDifferenceMs / 1000;
        },
        convertDateIntoLocalTimezone(inputDate) {
            if (!inputDate) {
                return 0;
            }

            try {
                const moment = require("moment-timezone");
                const inputTimeZone = "Etc/UTC"; // Assuming the input date is in UTC

                let targetTimeZone = "Europe/London";

                if (this.companyConfiguration.region == "ZA") {
                    targetTimeZone = "Africa/Johannesburg";
                }

                const parsedDate = moment.tz(inputDate, "YYYY-MM-DD HH:mm:ss", inputTimeZone);

                const outputDate = parsedDate.clone().tz(targetTimeZone);

                return outputDate.format("YYYY-MM-DD HH:mm:ss");

            } catch (error) {
                return inputDate;
            }

        },
        convertDateIntoLocalTimezoneFormat1(inputDate) {
            if (!inputDate) {
                return 0;
            }

            try {
                const moment = require("moment-timezone");
                const inputTimeZone = "Etc/UTC"; // Assuming the input date is in UTC

                let targetTimeZone = "Europe/London";

                if (this.companyConfiguration.region == "ZA") {
                    targetTimeZone = "Africa/Johannesburg";
                }

                const parsedDate = moment.tz(inputDate, "YYYY-MM-DD HH:mm", inputTimeZone);

                const outputDate = parsedDate.clone().tz(targetTimeZone);

                return outputDate.format("YYYY-MM-DD HH:mm");

            } catch (error) {
                return inputDate;
            }

        },
        formatTime(seconds) {
            const days = Math.floor(seconds / (3600 * 24));
            seconds -= days * 3600 * 24;

            const hours = Math.floor(seconds / 3600);
            seconds -= hours * 3600;

            const minutes = Math.floor(seconds / 60);
            seconds -= minutes * 60;

            const formattedSeconds = seconds.toFixed(2);

            let formattedTime = "";

            if (days > 0) {
                formattedTime += `${days} day${days > 1 ? 's' : ''} `;
            }

            if (hours > 0) {
                formattedTime += `${hours} hr${hours > 1 ? 's' : ''} `;
            }

            if (minutes > 0) {
                formattedTime += `${minutes} min${minutes > 1 ? 's' : ''} `;
            }

            if (seconds > 0 || formattedTime === "") {
                formattedTime += `${formattedSeconds} sec${formattedSeconds !== 1 ? 's' : ''}`;
            }

            return formattedTime;
        },
        async searchProcesses(event) {
            const [processData] = await Promise.all([
                ProcessService.searchCompanyProcesses(this.profile.companyId, event.query.toLowerCase())
            ]);

            this.filteredProcesses = processData.data;
        },
        async searchSprints(event) {
            const [sprintData] = await Promise.all([
                SprintService.searchCompanySprints(this.profile.companyId, event.query.toLowerCase())
            ]);

            this.filteredSprints = sprintData.data;
        },
        async searchUsers(event) {
            const [userData] = await Promise.all([
                UserService.searchCompanyUsers(this.profile.companyId, event.query.toLowerCase())
            ]);

            this.filteredUsers = userData.data;
        },
        async searchClients(event) {
            const [clientData] = await Promise.all([
                ClientService.searchCompanyClients(this.profile.companyId, event.query.toLowerCase())
            ]);

            this.filteredClients = clientData.data;
        },
        resetClientFileInput() {
            this.file = null;
            this.$refs.fileInput.value = ''; // clears input element
        },
        handleFileUpload(event) {
            const file = event.target.files[0];

            if (!file) {
                this.file = null;
                return;
            }

            const allowedTypes = [
                'application/pdf',
                'image/png',
                'image/jpeg'
            ];

            if (!allowedTypes.includes(file.type)) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Invalid file type',
                    detail: 'Only PDF, PNG, and JPG files are allowed.',
                    life: 3000
                });
                this.resetClientFileInput();
                return;
            }

            this.file = file;
        },
        async uploadFile() {

            if (this.task) {
                this.submitted = true;

                if (!this.file) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'No file selected.',
                        life: 3000
                    });
                }

                console.log('[Tasks][uploadFile] this.task = ', this.task);

                const formData = new FormData();
                formData.append('file', this.file);

                const originalName = this.file.name;
                const filenameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.')) || originalName;

                const storageRecord = {
                    companyId: this.profile.companyId,
                    clientId: this.task.clientId,
                    noteId: null,
                    taskId: this.task.id,
                    type: 'T',
                    provider: 'H',
                    filename: filenameWithoutExt,
                    simpleFilename: filenameWithoutExt,
                    contentType: this.file.type
                };

                // Append as a JSON string
                formData.append('storageRecord', new Blob([JSON.stringify(storageRecord)], {type: 'application/json'}));

                try {
                    const response = await axios.post('/api/storage/hetzner/upload', formData, {
                        headers: {
                            'Authorization': 'Bearer ' + this.userStore.accessToken,
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    console.log('[Task][uploadFile] Upload successful:', response.data);

                    try {
                        const [taskFilesData] = await Promise.all([
                            StorageService.getCompanyStorageForTask(this.profile.companyId, this.task.id),
                        ]);

                        this.taskFiles = taskFilesData.data;
                        console.log("[Tasks][callManageFiles] this.taskFiles = ", this.taskFiles);

                        this.submitted = false;

                    } catch (e) {
                        console.error("[Tasks][callManageFiles] Error fetching additional data = ", e);
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'File uploaded successfully',
                        life: 3000
                    });

                } catch (error) {
                    console.error('Error uploading file:', error);
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Upload Failed',
                        detail: 'File upload NOT successful',
                        life: 3000
                    });
                }
            }

            this.resetClientFileInput();
            this.submitted = false;
            this.activeTab = 17;
        },
        async deleteFile() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.specificFile.id) {

                    try {

                        await StorageService.deleteCompanyStorage(this.specificFile.id);

                        try {
                            const [taskFilesData] = await Promise.all([
                                StorageService.getCompanyStorageForTask(this.profile.companyId, this.task.id),
                            ]);

                            this.taskFiles = taskFilesData.data;
                            console.log("[Tasks][deleteFile] this.taskFiles = ", this.taskFiles);

                        } catch (e) {
                            console.error("[Tasks][deleteFile] Error fetching additional data = ", e);
                        }

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted file',
                            life: 3000
                        });

                    } catch (error) {
                        console.error('[Tasks][deleteFile] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete file. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.activeTab = 17;
            this.submitted = false;

        },
        async viewFile(data) {
            try {
                this.specificFile = data;

                const [response] = await Promise.all([
                    StorageService.downloadFile(this.profile.companyId, this.specificFile.id)
                ]);

                const blob = new Blob(
                    [response.data],
                    {type: this.specificFile.contentType}
                );

                const url = URL.createObjectURL(blob);
                window.open(url);

            } catch (error) {
                console.error('[Tasks][viewFile] Error:', error);
            }

        },
        async viewExternalFile(data) {
            try {
                this.specificFile = data;

                if (this.specificFile.filename) {
                    window.open(
                        this.specificFile.filename,
                        '_blank',
                        'noopener,noreferrer'
                    );
                }
            } catch (error) {
                console.error('[Tasks][viewExternalFile] Error:', error);
            }
        },
        async downloadFile(data) {
            try {
                this.specificFile = data;

                const [responseData] = await Promise.all([
                    StorageService.downloadFile(this.profile.companyId, this.specificFile.id)
                ]);

                const fullFilename = this.specificFile.filename;
                const displayName = fullFilename.includes('~')
                    ? fullFilename.substring(fullFilename.lastIndexOf('~') + 1)
                    : fullFilename;

                // Use the correct content type from the storage record
                const contentType = this.specificFile.contentType || 'application/octet-stream';

                const blob = new Blob([responseData.data], { type: contentType });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', displayName);
                document.body.appendChild(link);
                link.click();

                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Downloaded file',
                    life: 3000
                });


            } catch (error) {
                console.error('[Tasks][downloadFile] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to download file. Please try again.',
                    life: 3000
                });
            }
        },
        async addExternalFile() {
            if (this.task) {
                this.submitted = true;

                var storageRecord = {
                    companyId: this.profile.companyId,
                    clientId: this.task.clientId,
                    noteId: null,
                    taskId: this.task.id,
                    type: 'T',
                    provider: 'E',
                    contentType : 'application/pdf',
                    simpleFilename: this.externalFilename,
                    filename: this.externalLink
                };

                console.log('[OverviewFiles][addFile] storageRecord = ', storageRecord);

                await StorageService.addExternalFile(this.profile.companyId, storageRecord);

                try {
                    const [taskFilesData] = await Promise.all([
                        StorageService.getCompanyStorageForTask(this.profile.companyId, this.task.id),
                    ]);

                    this.taskFiles = taskFilesData.data;

                } catch (e) {
                    console.error("[Tasks][callManageFiles] Error fetching additional data = ", e);
                }
            }

            this.externalFilename = null;
            this.externalLink = null;
            this.submitted = false;
            this.activeTab = 17;
        },
        async updateFile() {
            this.submitted = true;

            console.log('[Tasks][updateFile] this.specificFile = ', this.specificFile);

            await StorageService.updateCompanyStorage(this.specificFile.id, this.specificFile);

            try {
                const [taskFilesData] = await Promise.all([
                    StorageService.getCompanyStorageForTask(this.profile.companyId, this.task.id),
                ]);

                this.taskFiles = taskFilesData.data;

            } catch (e) {
                console.error("[Tasks][updateFile] Error fetching additional data = ", e);
            }

            this.submitted = false;
            this.activeTab = 17;
        },
        async playTask(data) {
            this.submitted = true;
            this.task = data;

            if (this.task.id) {

                try {
                    var utcMoment = moment.utc();

                    var taskDto = {
                        startTimer: utcMoment.format('YYYY-MM-DD HH:mm:ss'),
                    };

                    await TaskService.updateTask(this.task.id, taskDto);

                    await this.loadData();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Started timer',
                        life: 3000
                    });

                } catch (error) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to start timer. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async endTask(data) {
            this.submitted = true;
            this.task = data;

            if (this.task.id) {

                try {
                    var utcMoment = moment.utc();

                    var taskDto = {
                        endTimer: utcMoment.format('YYYY-MM-DD HH:mm:ss'),
                    };

                    await TaskService.updateTask(this.task.id, taskDto);

                    await this.loadData();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Stopped timer',
                        life: 3000
                    });

                } catch (error) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to stop timer. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async createTask() {
            this.submitted = true;

            if (this.newTask.description) {

                try {
                    var tempProcess = "";
                    var tempSprint = "";
                    var tempUser = "";
                    var tempRequester = "";
                    var tempClient = "";

                    try {
                        tempProcess = this.newTask.process.id;
                    } catch (error) {
                        tempProcess = "";
                    }

                    try {
                        tempSprint = this.newTask.sprint.id;
                    } catch (error) {
                        tempSprint = "";
                    }

                    try {
                        tempUser = this.newTask.user.id;
                    } catch (error) {
                        tempUser = this.userStore.user.id;
                    }

                    try {
                        tempRequester = this.newTask.requester.id;
                    } catch (error) {
                        tempRequester = this.userStore.user.id;
                    }

                    try {
                        tempClient = this.newTask.client.id;
                    } catch (error) {
                        tempClient = "";
                    }

                    var newTaskDto = {
                        companyId: this.profile.companyId,
                        processId: tempProcess,
                        sprintId: tempSprint,
                        userId: tempUser,
                        clientId: tempClient,
                        requesterId: tempRequester,
                        description: this.newTask.description,
                        max: this.newTask.max,
                        note: this.newTask.note,
                        type: this.newTask.type,
                        severity: this.newTask.severity,
                        category: this.newTask.category,
                        priority: this.newTask.priority,
                        storyPoints: this.newTask.storyPoints,
                        clientVisible: this.newTask.clientVisible,
                        due: moment(this.newTask.due).format('YYYY-MM-DD HH:mm'),
                    };

                    await TaskService.createTask(this.profile.companyId, newTaskDto);

                    await this.loadData();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created task',
                        life: 3000
                    });

                } catch (error) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create task. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async updateTask() {
            this.submitted = true;

            if (this.task.id) {

                try {
                    var tempProcess = this.task.processName;
                    var tempSprint = this.task.sprintName;
                    var tempClient = this.task.clientName;
                    var tempUser = this.task.username;

                    try {
                        if (this.task.processName.id == null) {
                            tempProcess = this.task.processId;
                        } else {
                            tempProcess = this.task.processName.id;
                        }
                    } catch (error) {
                        tempProcess = this.task.processId;
                    }

                    try {
                        if (this.task.sprintName.id == null) {
                            tempSprint = this.task.sprintId;
                        } else {
                            tempSprint = this.task.sprintName.id;
                        }
                    } catch (error) {
                        tempSprint = this.task.sprintId;
                    }

                    try {
                        if (this.task.clientName.id == null) {
                            tempClient = this.task.clientId;
                        } else {
                            tempClient = this.task.clientName.id;
                        }
                    } catch (error) {
                        tempClient = this.task.clientId;
                    }

                    try {
                        if (this.task.username.id == null) {
                            tempUser = this.task.userId;
                        } else {
                            tempUser = this.task.username.id;
                        }
                    } catch (error) {
                        tempUser = this.task.userId;
                    }

                    var taskDto = {
                        description: this.task.description,
                        type: this.task.type,
                        severity: this.task.severity,
                        category: this.task.category,
                        priority: this.task.priority,
                        storyPoints: this.task.storyPoints,
                        clientVisible: this.task.clientVisible,
                        note: this.task.note,
                        processId: tempProcess,
                        sprintId: tempSprint,
                        clientId: tempClient,
                        userId: tempUser,
                        status: this.task.status
                    };

                    if (this.task.due && moment(this.task.due).isValid()) {
                        taskDto.due = moment(this.task.due).format('YYYY-MM-DD HH:mm');
                    }

                    await TaskService.updateTask(this.task.id, taskDto);

                    await this.loadData();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated task',
                        life: 3000
                    });

                } catch (error) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update task. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async completeTask() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.task.id) {

                    try {
                        var taskDto = {
                            status: 'C'
                        };

                        await TaskService.updateTask(this.task.id, taskDto);

                        const [taskData] = await Promise.all([
                            TaskService.getCompanyActiveTasks(this.profile.companyId)
                        ]);

                        this.originalTasks = taskData.data;
                        this.tasks = this.originalTasks.filter(task => task.userId === this.userStore.user.id);
                        this.userStore.setTasks(taskData.data)

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Completed task',
                            life: 3000
                        });

                    } catch (error) {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to complete task. Please try again.',
                            life: 3000
                        });
                    }
                }

            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async deleteTask() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.task.id) {

                    try {
                        await TaskService.deleteTask(this.task.id);

                        const [taskData] = await Promise.all([
                            TaskService.getCompanyActiveTasks(this.profile.companyId)
                        ]);

                        this.originalTasks = taskData.data;
                        this.tasks = this.originalTasks.filter(task => task.userId === this.userStore.user.id);
                        this.userStore.setTasks(taskData.data)

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted task',
                            life: 3000
                        });

                    } catch (error) {

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete task. Please try again.',
                            life: 3000
                        });
                    }
                }

            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async createSprint() {
            this.submitted = true;

            if (this.newSprint.name) {

                try {
                    var tempStart = null;

                    if (this.newSprint.start != null) {
                        tempStart = moment(this.newSprint.start).format('YYYY-MM-DD HH:mm');
                    }

                    var newSprintDto = {
                        companyId: this.profile.companyId,
                        name: this.newSprint.name,
                        description: this.newSprint.description,
                        start: tempStart,
                    };

                    await SprintService.createSprint(newSprintDto);

                    await this.loadSprints();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created sprint',
                        life: 3000
                    });

                } catch (error) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create sprint. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 10;
            this.submitted = false;
        },
        async updateSprint() {
            this.submitted = true;

            if (this.sprint.id) {

                try {

                    var tempStart = null;

                    if (this.sprint.start != null) {
                        tempStart = moment(this.sprint.start).format('YYYY-MM-DD HH:mm');
                    }

                    var tempEnd = null;

                    if (this.sprint.end != null) {
                        tempEnd = moment(this.sprint.end).format('YYYY-MM-DD HH:mm');
                    }

                    var sprintDto = {
                        id: this.sprint.id,
                        name: this.sprint.name,
                        description: this.sprint.description,
                        status: this.sprint.status,
                        start: tempStart,
                        end: tempEnd,
                    };

                    await SprintService.updateSprint(sprintDto);

                    await this.loadSprints();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated sprint',
                        life: 3000
                    });

                } catch (error) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update sprint. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 10;
            this.submitted = false;
        },
        async deleteSprint() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.sprint.id) {

                    try {
                        await SprintService.deleteSprint(this.sprint.id);
                        await this.loadSprints();

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted sprint',
                            life: 3000
                        });

                    } catch (error) {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete sprint. Please try again.',
                            life: 3000
                        });
                    }
                }

            }

            this.activeTab = 10;
            this.submitted = false;
        },
        async sendEmail() {
            this.submitted = true;

            if (this.task.id) {

                try {

                    var emailDto = {
                        companyId: this.profile.companyId,
                        userId: this.userStore.user.id,
                        emailSubject: this.email.emailSubject,
                        emailMessage: this.email.emailMessage
                    };

                    console.log("[PmClients][submitToolboxEmail] emailDto = ", emailDto);

                    const formData = new FormData();

                    // Add JSON as a Blob (important!)
                    formData.append(
                        "toolboxDto",
                        new Blob([JSON.stringify(emailDto)], { type: "application/json" })
                    );

                    // Add file (assuming you have this.file from input)
                    formData.append("file", this.file);

                    await ClientService.sendClientEmail(this.task.clientId, formData);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Sent email',
                        life: 3000
                    });

                    this.email.emailSubject = '';
                    this.email.emailMessage = '';

                    this.resetClientFileInput();

                } catch (error) {
                    console.error('[Tasks][sendEmail] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to send email. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;

        },
        async sendSms() {
            this.submitted = true;

            if (this.task.id) {

                try {

                    var smsDto = {
                        companyId: this.profile.companyId,
                        userId: this.userStore.user.id,
                        smsMessage: this.sms.smsMessage,
                    };

                    console.log("[Tasks][sendSms] smsDto = ", smsDto);

                    const response = await ClientService.sendClientSms(this.task.clientId, smsDto);
                    console.log('[Tasks][sendSms] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Sent SMS',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[Tasks][sendSms] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to send SMS. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;

        },
        handleEmailFileUpload(event) {
            const file = event.target.files[0];

            if (!file) {
                this.file = null;
                return;
            }

            const allowedTypes = [
                'application/pdf'
            ];

            if (!allowedTypes.includes(file.type)) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Invalid file type',
                    detail: 'Only PDF files are allowed.',
                    life: 3000
                });
                this.resetClientFileInput();
                return;
            }

            this.file = file;
        },
    },
};
</script>

<style scoped>
/* Target the DataTable container (which contains the actual <table>) */
.my-custom-datatable .p-datatable-wrapper {
    overflow-x: auto; /* Ensure horizontal scrollbar appears if content overflows */
}

/* Apply table-layout: fixed to the actual <table> element */
.my-custom-datatable .p-datatable-table {
    table-layout: fixed; /* Crucial for enforcing min/max widths */
    width: 100%; /* Important to make fixed layout work */
}

/* Ensure column headers and cells respect their widths */
/* These styles might already be applied by PrimeVue based on :style="column.style" */
/* but adding them explicitly here can sometimes provide a fallback or override */
.my-custom-datatable .p-datatable-thead th,
.my-custom-datatable .p-datatable-tbody td {
    white-space: nowrap; /* Prevent text wrapping within a cell by default */
    overflow: hidden; /* Hide overflowed text */
    text-overflow: ellipsis; /* Show ellipsis for overflowed text */
    box-sizing: border-box; /* Include padding and border in element's total width */
}

a {
    text-decoration: none;
}

::v-deep(.p-datatable-frozen-tbody) {
    font-weight: bold;
}

::v-deep(.p-datatable-scrollable .p-frozen-column) {
    font-weight: bold;
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

.type-badge,
.status-badge,
.confirmation-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.type-badge {
    &.status-R {
        background: #11B080FF;
        color: #11170c;
    }

    &.status-S {
        background: #A166A8FF;
        color: #11170c;
    }

    &.status-B {
        background: #FFCDD2;
        color: #11170c;
    }

    &.status-O {
        background: #FEEDAF;
        color: #11170c;
    }

    &.status-U {
        background: #B3E5FC;
        color: #11170c;
    }

    &.status-P {
        background: #ECCFFF;
        color: #11170c;
    }

    &.status-C {
        background: #c75226;
        color: #11170c;
    }

    &.status-D {
        background: #a6e572;
        color: #11170c;
    }

    &.status-E {
        background: #92ceea;
        color: #11170c;
    }

    &.status-F {
        background: #ECCFFF;
        color: #11170c;
    }

    &.status-G {
        background: #bc69f1;
        color: #11170c;
    }

    &.status-H {
        background: #C8E6C9;
        color: #11170c;
    }

    &.status-M {
        background: #b3a0d9;
        color: #11170c;
    }

    &.status-Q {
        background: #e0d0cd;
        color: #11170c;
    }

    &.status-T {
        background: #94ecd2;
        color: #11170c;
    }

    &.status-I {
        background: #a6e572;
        color: #11170c;
    }

    &.status-N {
        background: #92ceea;
        color: #11170c;
    }

    &.status-B {
        background: #c75226;
        color: #11170c;
    }

}

.status-badge {
    &.status-I {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-S {
        background: #A166A8FF;
        color: #11170c;
    }

    &.status-T {
        background: #94ecd2;
        color: #11170c;
    }

    &.status-W {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-C {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-R {
        background: #B3E5FC;
        color: #23547B;
    }
}

.confirmation-badge {
    &.status-Y {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-N {
        background: #FFCDD2;
        color: #C63737;
    }
}

.tabview-custom {

    i,
    span {
        vertical-align: middle;
    }

    span {
        margin: 0 .5rem;
    }
}

.p-tabview p {
    line-height: 1.5;
    margin: 0;
}

.accordion-custom {

    i,
    span {
        vertical-align: middle;
    }

    span {
        margin: 0 .5rem;
    }
}

.p-accordion p {
    line-height: 1.5;
    margin: 0;
}

.mb-2 {
    margin-bottom: 1rem;
}

.mr-2 {
    margin-right: 1rem;
}

.button-container {
    display: inline-flex;
    align-items: center;
}

.split-button,
.button {
    margin: 0;
    padding: 0;
}

:deep(.row-overdue > td) {
    background-color: #ffe5e5 !important;
}

:deep(.row-due-soon > td) {
    background-color: #fff4e5 !important;
}

.datatable-scroll-container {
    overflow-x: auto;
}

:deep(.p-datatable-wrapper) {
    overflow-x: auto !important;
    scrollbar-width: auto;
}

:deep(.p-datatable-table) {
    min-width: max-content;
}

.scroll-help {
    margin-top: 0.5rem;
    font-size: 0.85rem;
    color: #666;
    text-align: center;
}

:deep(.p-datatable-wrapper)::-webkit-scrollbar {
    height: 14px;
}

:deep(.p-datatable-wrapper)::-webkit-scrollbar-track {
    background: #e5e7eb;
}

:deep(.p-datatable-wrapper)::-webkit-scrollbar-thumb {
    background: #9ca3af;
    border-radius: 8px;
}

:deep(.p-datatable-wrapper)::-webkit-scrollbar-thumb:hover {
    background: #6b7280;
}

</style>
